import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const BOOK_URL = "https://cleaning.masayahospitality.com";

export default function Cleaning() {
  return (
    <div data-testid="cleaning-page" className="pt-28 md:pt-32">
      <section className="px-6 md:px-12 min-h-[70vh] flex items-center">
        <div className="max-w-4xl mx-auto w-full text-center">
          <Reveal>
            <span className="text-xs sm:text-sm tracking-[0.2em] uppercase font-medium text-[#8A9A86]">
              Cleaning Services
            </span>
          </Reveal>
          <Reveal delay={0.1}>
            <h1 className="mt-6 text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-light leading-[1.02] text-[#1C1917]">
              Masaya Hospitality Cleaning Services
            </h1>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 text-lg md:text-xl text-[#44403C] leading-relaxed font-light max-w-2xl mx-auto">
              Professional cleaning and turnover services for vacation rentals,
              furnished stays, and homes.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="mt-12"
            >
              <a
                href={BOOK_URL}
                data-testid="book-cleaning-btn"
                rel="noopener"
                className="inline-flex items-center gap-2 rounded-full bg-[#1C1917] text-white px-8 md:px-10 py-4 hover:bg-[#44403C] transition-colors duration-300 font-medium text-sm md:text-base"
              >
                Book Cleaning Services
                <ArrowUpRight className="w-4 h-4 md:w-5 md:h-5" strokeWidth={1.75} />
              </a>
              <p className="mt-6 text-sm text-[#78716C] font-light max-w-xl mx-auto">
                Looking for professional cleaning? Visit our dedicated Cleaning
                Services website to view services and book online.
              </p>
            </motion.div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
